const button = document.querySelector('[data-menu-button]');
const links = document.querySelector('[data-nav-links]');

if (button && links) {
  const setOpen = (open) => {
    links.classList.toggle('open', open);
    button.setAttribute('aria-expanded', String(open));
  };
  button.addEventListener('click', () => setOpen(!links.classList.contains('open')));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });
  document.addEventListener('click', (e) => {
    if (!links.contains(e.target) && !button.contains(e.target)) setOpen(false);
  });
}

document.querySelectorAll('[data-year]').forEach((el) => {
  el.textContent = new Date().getFullYear();
});
